// extracted by mini-css-extract-plugin
export var quote = "RichTextConverter-module--quote--twCBi";
export var playerWrapper = "RichTextConverter-module--player-wrapper--1Hw-e";
export var embeddedAsset = "RichTextConverter-module--embedded-asset--18lQH";
export var fullWidth = "RichTextConverter-module--full-width--3S8uV";
export var left = "RichTextConverter-module--left--1JXx5";
export var right = "RichTextConverter-module--right--32Zdn";
export var figure = "RichTextConverter-module--figure--34FCj";
export var reactPlayer = "RichTextConverter-module--react-player--2NzH8";